/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetMonthlyInterestCalculationRequest} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'
import {GetMonthlyInterestCalculationResponse} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'


export const getMonthlyInterestCalculation = (request: GetMonthlyInterestCalculationRequest, options?: CashRequestOptions) => post<GetMonthlyInterestCalculationRequest, GetMonthlyInterestCalculationResponse>("/2.0/cash/get-monthly-interest-calculation", request, {...options, rejectOnError: true })